export const navLinks = [
  { name: "For Business", href: "/b2b" },
  { name: "Newsletter", href: "https://www.stayingahead.com/" },
  { name: "Contact Us", href: "#contact" },
  {
    name: "Apply as Mentor",
    href: "https://docs.google.com/forms/d/e/1FAIpQLSehQA4MvUwfcCW3cGEiDZYnm9CkvIP8SsfNmru9_IUy957pww/formResponse",
  },
];
